import { cn, Text } from '@viapeople/components'
import type { ComponentProps, HeaderCustomProps } from './types'

export function FormsHeader({ component }: ComponentProps) {
	const { label, labelColor, size, backgroundColor } = component.custom as HeaderCustomProps
	return (
		<div
			className={cn('w-full', backgroundColor && 'p-4 rounded-md')}
			style={{ backgroundColor: backgroundColor || undefined }}>
			<Text variant={size} style={{ color: labelColor }} className={'font-semibold'}>
				{label}
			</Text>
		</div>
	)
}
